export const ACCOUNT_TYPE = {
  STUDENT: "student",
  INSTRUCTOR: "instructor",
  ADMIN: "admin",
}

export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
}
